
<template>
    <div  class="">
      <div class="flx-center">
        <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/business/overseas_banner.jpg) no-repeat center', backgroundSize: '100%' }"></div>
      </div>
      <div class="business">
        <!-- 美通海外仓 -->
   
      <div>
        <div class="container" >
             <div >
               <div class=" button-group">
                 <div class="button-group-item"  style="position: absolute;top:800px;">
                   <el-button
                    v-for="(item, index) in buttons"
                    :key="index"
                    :class="{ 'active': activeIndex === index }"
                    @click="setActive(item,index)"
                  >
                    <div class="btn-text" style="">
                     {{ item.label }}
                   </div>
                  </el-button>
                 </div>
               
                </div>
             </div>
              </div>
              <div style="position: relative;">
                <div class="business-imgRight">
                  <img :src="$ossUrl+'images/business/circel.png'" alt="">
               </div>
               <div class="container">
                <div class="service " style="position: relative;">
                     <div class="business-imgLeft">
                       <img :src="$ossUrl+'images/business/listen.png'" alt="">
                     </div>


                    <div class="service-text" style="padding-top: 70px;margin:130px 0 0 0px;">
                    <div >美通海运</div><i class="serviceNews"></i></div>
                    <div class="flx-center">
                      <div class="service-content">
                        美通海运渠道多样，与全球各大船东建立战略合作，自建海外仓与自有清关团队，团队经验丰富，专业能力强，尾程派送方式多样且灵活，时效稳定，安全无忧。

                        </div>
                    </div>
                   </div>
               </div>
           </div>
      </div>
          <!-- 参考时效 -->
          <div class="service-text-bg" style="padding-bottom: 58px;">
            <div class="container ">
              <div class="service-text" style="padding-top: 70px;margin:130px 0 0 0px;">
                <div >参考时效</div><i class="serviceNews"></i></div>
                <div class="reference flx-align-start" style="margin-top:70px;">
                    <span class="referenceContry">美国</span>
                    <span class="referenceContent">美森特快极致时效12天；普船美西20-35天；6大热门仓20-30天</span>
               </div>
               <div class="reference flx-align-start">
                    <span class="referenceContry">欧盟</span>
                    <span class="referenceContent">28-35天</span>
               </div>
               <div class="reference flx-align-start">
                    <span class="referenceContry">英国</span>
                    <span class="referenceContent">28-35天</span>
               </div>
               <div class="reference flx-align-start">
                    <span class="referenceContry">加拿大</span>
                    <span class="referenceContent">派普船45~55天，快船23~30天</span>
               </div>
               <div class="reference flx-align-start">
                    <span class="referenceContry">墨西哥</span>
                    <span class="referenceContent">专线35~45天，快线21~25天</span>
               </div>
               <div class="reference flx-align-start">
                    <span class="referenceContry">日本</span>
                    <span class="referenceContent">快船12-13天；海派15-18天；海卡23-25天</span>
               </div>
            </div>
           
           
        
          </div> 
          <!-- 服务线路 -->
          <div class="container">
            <div class="service " style="padding: 100px 0 0 0;">
              <div class="service-text">
              <div >服务线路</div><i class="serviceNews"></i></div>
              <el-row style="margin-top: 70px;">
              <el-col :span="12" v-for="(item,index) in serviceList" :key="index">
                <div class="ServiceLineBox commonUI">
                      <div class="ServiceLineTitle">
                        <img style="width: 32px;margin-right: 16px;" :src="item.icon" alt="icon" />{{item.title}}
                      </div>
                      <el-tabs v-model="item.activeName"  @tab-click="handleClick(item,index)">
                          <el-tab-pane label="产品渠道" name="first">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.channelData">
                            </div> 
                          </el-tab-pane>
                          <el-tab-pane label="产品优势" name="second">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.goodData">
                              
                            </div> 
                          </el-tab-pane>
                          <el-tab-pane label="产品服务" name="third" v-if= "item.serviceData">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.serviceData">
                               
                            </div> 
                          </el-tab-pane>
                        </el-tabs>
                  </div>
              </el-col>
         
            </el-row>
            
             </div>
          </div>
          <!-- 运输流程 -->
          <!-- <div class="service-text-bg" style="padding-bottom: 180px;">
          
              <div class="container ">
              <div class="service-text" style="padding-top: 100px;margin:130px 0 0 0px;">
                <div >运输流程</div><i class="serviceNews"></i></div>
                </div>
            <div class="container " style="margin-top: 70px;position: relative;">
              <el-row>
                <el-col :span="24" class="flx-align-start">
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation1.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">01</div>
                        <div class="transportationProContent">客户系统下单</div>
                      </div>
                  </div>
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation2.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">05</div>
                        <div class="transportationProContent">到达监管仓</div>
                      </div>
                  </div>
                </el-col>
                <el-col :span="24" class="flx-align-start">
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation3.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">02</div>
                        <div class="transportationProContent">包裹装车发送至口岸</div>
                      </div>
                  </div>
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation4.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">06</div>
                        <div class="transportationProContent">监管仓清关</div>
                      </div>
                  </div>
                </el-col>
                <el-col :span="24" class="flx-align-start">
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation5.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">03</div>
                        <div class="transportationProContent">口岸换装报关</div>
                      </div>
                  </div>
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation6.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">07</div>
                        <div class="transportationProContent">尾程灵活派送</div>
                      </div>
                  </div>
                </el-col>
                <el-col :span="24" class="flx-align-start">
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation7.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">04</div>
                        <div class="transportationProContent">出境</div>
                      </div>
                  </div>
                  <div class="transportationProcess flx-align-only-start ">
                      <img  src="@/assets/images/business/overSea/transportation/transportation8.png" alt="">
                      <div class="">
                        <div class="transportationProTitle">08</div>
                        <div class="transportationProContent">AMZ仓库、第三方海外仓收货并上架</div>
                      </div>
                  </div>
                </el-col>
              
                
              </el-row>
         
           
            </div>
          </div>  -->
      </div>
    </div>
  </template>
  <script>
  
  
  /**
   * Index-1 component
   */
  export default {
      name:"sea",
    components: {
    },
    data(){
      return {
        activeName:'first',
        activeIndex: 1, // 默认选中第一个按钮
        buttons: [
          { label: '海外仓',transportMode:'OCEAN' },
          { label: '头程海运',transportMode:'AIR' },
          { label: '头程卡航',transportMode:'RAIL' },
          { label: '头程空运',transportMode:'ROAD' }
        ],
        activePropsIndex:0,
        buttonProps: [
          { contry: '加拿大',capital:'温哥华/多伦多'},
          { contry: '美国',capital:'洛杉矶/芝加哥'}, 
          { contry: '墨西哥',capital:'墨西哥'},
          { contry: '英国',capital:'伦敦'},
          { contry: '比利时',capital:'烈日'},
          { contry: '德国',capital:'科隆'},
          { contry: '法国',capital:'巴黎'},
          { contry: '日本',capital:'大阪府'},
        ],
        serviceList:[
          {
          title:'美国快线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/US.png',
          channelData:'1.美森特快极致时效12自然日签收，快递时效稳定在13自然日提取；<br>2.普船优选OA联盟优势航线，美西20-35自然日签收；<br> 3.六大热门仓OA优选整柜直送，时效20-30个自然日签收，无丢货，无额外费用；',
          goodData:'1.精选OA联盟/美森优势航线；COSCO/OOCL/EMC/ZIM/MASTON<br>2.自有船司合约，自建美国海外仓，16年海运操作团队经验；<br> 3.强大的美国海外资源，可实现美国全境整柜直送；',
          serviceData:null

          },
          {
          title:'欧盟快线',
          activeName:'second',
          icon:this.$ossUrl+'images/business/overSea/OM.jpg',
          channelData:'开船到提取，28-35个自然日；',
          goodData:'CES明星航线，船东直接签约，卸船后3个工作日内可提柜；',
          serviceData:'清关模式：<br>1.单票清关，100%客户自主vat，递延清关（清关不交vat）；<br>2.拒接双清包税；<br>清关点：LGG、CDG，海外自建监管仓、清关团队。<br>尾程派送：快递派：UPS/DPD/DHL派送，自有账号；卡派：整车专送，零担拼车，自有车队。'
          },
          {
          title:'英国快线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/GB.png',
          channelData:'开船到提取，28-35个自然日；',
          goodData:'船东直接签约，OA明星航线；',
          serviceData:'清关模式：<br>1.单票清关，100%客户自主vat，递延清关（清关不交vat）；<br>2.拒接双清包税；<br>清关点：LGG、CDG，海外自建监管仓、清关团队。<br>尾程派送：快递派：UPS/DPD/DHL派送，自有账号；卡派：整车专送，零担拼车，自有车队。'
          },
          {
          title:'加拿大快线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/CA.png',
          channelData:'海派普船45~55自然日，美森快船23~30自然日；',
          goodData:'美森正班快线，自建团队转运、陆运卡车过境、查验率低；',
          serviceData:null
          },
          {
          title:'墨西哥快线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/MX.png',
          channelData:'海运专线35~45自然日，海运快线21~25自然日；',
          goodData:'1.直航主要到曼萨尼约、拉萨罗港口清关；<br>2.头程COSCO深度绑定合作，保舱保柜；<br>3.自有海外仓和卡车派送团队；',
          serviceData:null
          },
          {
          title:'日本快线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/JP.png',
          channelData:'1.快船截单后12-13自然日签收；<br>2.海派开船后15-18自然日签收；<br>3.海卡开船后23-25日签收；<br>',
          goodData:'深圳首选德翔，上海快船固定用锦江；',
          serviceData:'清关模式：<br>海派单票清关 / 整柜清关 相结合；<br>清关点：大阪 /东京。<br>尾程派送：快递派：佐川、西浓，黑猫。 卡派：物流整车专送（GREEN BOX ,福田运通）自有卡车。'
          },
      ]
      }
    },
    methods: {
      setActive(item,index) {
      if(index === 1){
        this.$router.push({
          name:'sea'
        })
      }else if(index === 2){
        this.$router.push({
          name:'road'
        })
      }else if(index === 3){
        this.$router.push({
          name:'air'
        })
      }else {
        this.$router.push({
          name:'business'
        })
      }
      // this.activeIndex = index;
      

    },
    }
  };
  </script>
<style src="../index.css" scoped>
  
  
  </style>